<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-clock-rotate-left"></i>
    </div>
    <div>
      <h2 class="dialog-title">{{ getObjectDescription() }} History</h2>
      <p class="dialog-subtitle">{{ dialogData.objectDescription }}</p>
    </div>
  </div>
  @if( dialogData.objectStatus != null ) {
    <span class="history-status-badge badge" [ngClass]="{
          'badge-new': dialogData.objectStatus.id == 1 || dialogData.objectStatus.id == 40 || dialogData.objectStatus.id == 60,
          'badge-pending': dialogData.objectStatus.id == 2 || dialogData.objectStatus.id == 41 || dialogData.objectStatus.id == 61,
          'badge-processing': dialogData.objectStatus.id == 3 || dialogData.objectStatus.id == 42 || dialogData.objectStatus.id == 62 || dialogData.objectStatus.id == 63,
          'badge-rejected': dialogData.objectStatus.id == 4 || dialogData.objectStatus.id == 7 || dialogData.objectStatus.id == 43 || dialogData.objectStatus.id == 44,
          'badge-reload': dialogData.objectStatus.id == 5 || dialogData.objectStatus.id == 45,
          'badge-approved': dialogData.objectStatus.id == 6 || dialogData.objectStatus.id == 46
        }">
      <span class="badge-dot"></span>{{dialogData.objectStatus | objectdesc}}
    </span>
  }
  <button class="dialog-close" (click)="onClose()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <div class="history-modal-timeline">
    @for( obj of logMessages; track obj ) {
      <div class="timeline-item">
        <div class="timeline-dot-wrap">
          <div class="timeline-dot" [ngClass]="getTimelineDotClass(obj.messageType)">
            <i class="fa-solid" [ngClass]="getTimelineIconClass(obj.messageType)" style="font-size: 11px;"></i>
          </div>
        </div>
        <div class="timeline-content">
          <div class="timeline-msg">{{ obj.message }}</div>
          <div class="timeline-meta">{{ obj.user }} · {{ obj.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}</div>
        </div>
      </div>
    } 
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <form [formGroup]="messageForm" class="history-comment-box" (ngSubmit)="onSubmit()">
    <div class="history-comment-avatar">{{ stateService.getUserInitials() }}</div>
    <mat-form-field appearance="outline" style="flex: 1;">
      <input
        matInput
        formControlName="message"
        placeholder="Please write a comment..."
        >
        <!-- (keydown.enter)="onSubmit()" -->
    </mat-form-field>
    <button type="button" class="btn-blue" (click)="onSubmit()" [disabled]="!(this.dialogData.allowAdd && this.messageForm.valid)">
      <i class="fa-solid fa-paper-plane" style="margin-right: 4px;"></i>
      Enviar
    </button>
  </form>
</mat-dialog-actions>
